import React from "react";
import {
  Box,
  Hidden,
  Heading,
  Text,
  Columns,
  Column,
  TileLink,
} from "@origin-digital/ods-core";
import {
  IconSupportAgent,
  IconChevronRightSmall,
} from "@origin-digital/ods-icons";
import { content } from "src/components/ContactUs/content";

const ContactUsTitleRow = () => (
  <Box
    display="flex"
    width="full"
    flexDirection="row"
    alignItems="center"
    justifyContent={{ xs: "space-between", lg: "flex-start" }}
    gap="small"
  >
    <Heading component="h3" variant="h2">
      {content.headline}
    </Heading>
    <Box display="flex" position="relative" left="xxsmall">
      <IconChevronRightSmall
        variant="solid"
        size="xsmall"
        color="neutralDark"
      />
    </Box>
  </Box>
);

const ContactUsTileHeader = () => (
  <Box
    display="flex"
    width="full"
    flexDirection={{ xs: "column", lg: "row-reverse" }}
    paddingX={{ xs: "large", sm: "xlarge" }}
    height="full"
    gap={{ xs: "medium", lg: "xlarge", xl: "xxlarge" }}
  >
    <Hidden above="lg">
      <Box display="flex">
        <IconSupportAgent size="smallmedium" />
      </Box>
    </Hidden>
    <Hidden below="lg">
      <Box display="flex">
        <IconSupportAgent size="medium" />
      </Box>
    </Hidden>
    <Box display="flex" width="full" flexDirection="column" gap="small">
      <ContactUsTitleRow />
      <Text tone="neutralDark">{content.byline}</Text>
    </Box>
  </Box>
);

const ContactUsTileBody = () => (
  <Box
    display="flex"
    width="full"
    flexDirection="column"
    paddingY={{ xs: "xlarge", lg: "xxlarge" }}
  >
    <ContactUsTileHeader />
  </Box>
);

const ContactUsCard = () => (
  <Box display="flex" height="full" width="full">
    <TileLink
      href={content.href}
      dataId="contact-us"
      hideChevron
      cardProps={{
        borderRadius: "medium",
        backgroundColor: "cardBackgroundSecondary",
        paddingXSpecific: "none",
        paddingYSpecific: "none",
        height: "full",
      }}
    >
      <ContactUsTileBody />
    </TileLink>
  </Box>
);

export const ContactUs: React.FC = () => (
  <Box id="contact" marginX={{ xs: "medium", sm: "none" }}>
    <Box marginBottom={{ xs: "medium", lg: "large" }}>
      <Heading component="h2" variant="h4">
        {content.heading}
      </Heading>
    </Box>
    <Columns collapseBelow="lg" space={{ xs: "medium", xl: "large" }}>
      <Column width="1/2" alignSelf="stretch">
        <ContactUsCard />
      </Column>
    </Columns>
  </Box>
);
